module.exports = __webpack_public_path__ + "img/shield_fail.ec7298b3.svg";